import React, { useState, useEffect } from "react";
import "./StatsActivity.scss";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
// import { Scrollbars } from "react-custom-scrollbars"

function StatsActivity() {
  const [filter, setFilter] = useState(false);
  useEffect(() => {
    document.body.classList.toggle("filterActive", filter);
    document.querySelector(".filter-button").classList.toggle("active", filter);
    document
      .querySelector(".filter-list-box-wrap")
      .classList.toggle("filter-open", filter);
  }, [filter]);
  return (
    <>
      <Header />
      <section className="stats-rankings">
        <div className="exploreCollections">
          <div className="container">
            <div className="section-title">
              <h2>RECENT ACTIVITY </h2>
            </div>
            <div className="filter-wrap">
              <div className="filter-wrap__btns">
                <button
                  className="filter-button"
                  onClick={() => setFilter(!filter)}
                >
                  <div className="img-box">
                    <i className="material-icons-outlined">filter_list</i>
                  </div>
                  <span>Show Filters</span>
                </button>
                <button className="filter-button">
                  <div className="img-box">
                    <i className="material-icons-outlined">sort</i>
                  </div>
                  <span>Sort</span>
                </button>
              </div>
            </div>
            <div className="filter-list-box-wrap">
              <div className="nft-details__activity w-full">
                <div className="nft-details__activity-table">
                  <table width="100%" cellspacing="7px" cellpadding="0">
                    <thead>
                      <tr>
                        <th>Event</th>
                        <th>Item</th>
                        <th>Price</th>
                        <th>From</th>
                        <th>To</th>
                        <th>Time</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            local_offer_outlined
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                      <tr>
                        <td>
                          <i className="material-icons-outlined">
                            hourglass_empty_icon
                          </i>
                          Purchase
                        </td>
                        <td>
                          <a href="/" className="item-img__wrapp">
                            <div className="item-img">
                              <img src="../images/nft-details.jpg" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <img
                            className="prc"
                            src="../images/eth.png"
                            alt="eth"
                          />
                          88.069
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            anotherfren
                          </a>
                        </td>
                        <td>
                          <a href="/">
                            <div className="user-img">
                              <img src="../images/artist1.png" alt="eth" />
                            </div>
                            0x3611
                          </a>
                        </td>
                        <td>an hour ago</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
            {/* <div className="button-wrap">
              <a href="/" className="button purple-outline">
                Show More
              </a>
            </div> */}
          </div>
        </div>
      </section>
      <Footer />
    </>
  );
}

export default StatsActivity;
